import Button from '@pelckmans/elementis/components/button';
import { useToast } from '@pelckmans/elementis/components/toast';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { TOAST_ID } from '../../../../../constants/ToastIds';
import ModalContext from '../../../../../contexts/ModalContext';
import AddLicenseModal from '../../../../../shared-components/AddLicenseModal';
import ModuleContext from '../../../_contexts/ModuleContext';

const BASE = 'PAGES.TOC_LEVEL.SECTIONS.TEACHER.MATERIAL';

export function useWithLicenseCheck() {
  const { t } = useTranslation();
  const { showModal } = useContext(ModalContext);
  const { addToast, removeToast } = useToast();
  const { selectedModule, refetch: refetchModule } = useContext(ModuleContext);

  const hasDocumentLicenseForTeacher = selectedModule?.licenses.hasDocumentLicenseForTeacher;

  return {
    hasLicense: hasDocumentLicenseForTeacher,
    licenseCheck: (callback?: () => void) => () => {
      if (!hasDocumentLicenseForTeacher) {
        addToast({
          id: TOAST_ID.NO_LICENSE,
          variant: 'warning',
          title: t(`${BASE}.TOAST.NO_LICENSE.TITLE`),
          children: t(`${BASE}.TOAST.NO_LICENSE.TEXT`),
          actions: {
            role: undefined,
            'aria-label': undefined,
            children: (
              <Button
                prominence="warning"
                onClick={() => {
                  showModal(
                    <AddLicenseModal
                      id="add-license-modal"
                      onRefetch={() => {
                        refetchModule();
                      }}
                    />,
                  );
                  removeToast(TOAST_ID.NO_LICENSE);
                }}
              >
                {t(`${BASE}.TOAST.NO_LICENSE.ACTIONS.BUTTON.TEXT`)}
              </Button>
            ),
          },
        });

        return;
      }

      if (callback) callback();
    },
  };
}
